import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import {
    convertObjectToQueryParams,
    removeEmptyFieldsFromObject,
} from 'src/utils/util';
import axios from 'src/api/Api';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    SET_DERIVED_TERRITORIES_SUCCESS,
    SET_DERIVED_TERRITORIES_FAILURE,
} from '../actions';

export default function* getDerivedTerritories(action) {
    const params = convertObjectToQueryParams(
        removeEmptyFieldsFromObject({ ...action.payload }),
        true
    );
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/surgery/derivedterritories?${params}`;

    try {
        const result = yield axios.get(url).then((response) => response.data);
        yield put({
            type: SET_DERIVED_TERRITORIES_SUCCESS,
            interTerritoryId: result.interTerritory || '',
            nonInterTerritoryId: result.nonInterTerritory || '',
            derivedResponse: result,
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: SET_DERIVED_TERRITORIES_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
